module.exports = __webpack_public_path__ + "static/Bannervid0120121-e0fba752ca2ad19d1db2ba0b1f455112.mp4";